import { Grid } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';
import { domoUrl } from './embed';



export function DomesticReport() {
	const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state.epiProps.clergyCompReportSettingsState.epiContent);
	return (
		<>
			<DividerSection removeDivider>
				<div className='clergycomp-infographic-header'>
					<h2>{settings?.hisCompLabel}</h2>
				</div>
				<Grid container spacing={2}>
					<Grid item xs={6} >
						<div className='clergycomp-infographic'>
							<iframe
								title="global-clergy-comp"
								src={`${domoUrl}/api/card?reportName=${settings?.globalClergyCompReportId || 'IRgJMXr'}`}
								name={settings?.globalClergyCompReportId || 'IRgJMXr'}
								data-group='unfiltered'
								id='global-clergy-comp'
								width='445' height='290'
								marginHeight={0}
								marginWidth={0}
								frameBorder={0}
							/>
						</div>

					</Grid>
					<Grid item xs={6} >
						<div className='clergycomp-infographic'>
							<iframe
								title="global-clergy-count"
								src={`${domoUrl}/api/card?reportName=${settings?.globalClergyCountReportId || 'IR0RD35'}`}
								name={settings?.globalClergyCountReportId || 'IR0RD35'}
								data-group='unfiltered'
								id='global-clergy-count'
								width='445' height='290'
								marginHeight={0}
								marginWidth={0}
								frameBorder={0}
							/>
						</div>

					</Grid>

				</Grid>
			</DividerSection>
		</>
	);
}